import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * Password input with a show/hide eye toggle.
 * Matches the shadcn <Input /> styling so it can be a drop-in replacement.
 *
 * Props: forwards all standard input props (value, onChange, required, placeholder, etc.)
 *        plus a `testIdSuffix` used to derive data-testid for the toggle button.
 */
export default function PasswordInput({
  value,
  onChange,
  required = false,
  placeholder = "••••••••",
  autoComplete = "current-password",
  className = "",
  testId,
  testIdSuffix = "password",
  ...rest
}) {
  const [show, setShow] = useState(false);
  const toggleTestId = `${testIdSuffix}-toggle`;
  return (
    <div className="relative">
      <Input
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className={`pr-10 ${className}`}
        data-testid={testId}
        {...rest}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((v) => !v)}
        className="absolute top-1/2 -translate-y-1/2 right-2 rtl:right-auto rtl:left-2 p-1 text-espresso/50 hover:text-espresso transition-colors"
        aria-label={show ? "Hide password" : "Show password"}
        data-testid={toggleTestId}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
